<div class="membership">

  <!-- Pricing -->
  <div class="section-pricing">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col">
          <div class="text-center">
            <h1>Crystal clear pricing</h1>
            <br/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xxl-10 offset-xxl-1">
          <app-pricing-boxes [isHideRegionSelection]="false"/>
        </div>
      </div>
    </div>

    <br/>
    <br/>
  </div>

  <!-- Team -->
  <div class="section-team">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="box text-center">
            <h4>Interested in Croissant for your team? <a routerLink="/team-plans" class="underline">Get in touch!</a></h4>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
  </div>

  <div class="section-benefits">
    <br/>
    <br/>
    <br/>
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
          <div class="row">
            <div class="col-12 col-md-4">
              <h4>Included in all plans:</h4>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-8">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="benefits">
                    <p class="benefit-title"><strong>✓&nbsp;&nbsp;&nbsp;Rollover hours</strong></p>
                    <p class="benefit-description">Didn’t use all your hours this month? No worries, we’ll automatically roll them over for you for up to 6 months.</p>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="benefits">
                    <p class="benefit-title"><strong>✓&nbsp;&nbsp;&nbsp;24/7 access to select workspaces</strong></p>
                    <p class="benefit-description">Work all night &amp; weekend if you’d like! Doors unlock electronically via the app for maximum ease.</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="benefits">
                    <p class="benefit-title"><strong>✓&nbsp;&nbsp;&nbsp;{{ NUM_SPACES }}+ spaces in the network</strong></p>
                    <p class="benefit-description">Visit any of our wonderful partner locations around the world.</p>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="benefits">
                    <p class="benefit-title"><strong>✓&nbsp;&nbsp;&nbsp;Stay productive on the go</strong></p>
                    <p class="benefit-description">Get work done when you’re traveling to any of Croissant’s {{ NUM_CITIES }}+ cities</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <br/>
    <br/>
  </div>

  <!-- FAQ -->
  <div class="section-faq">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
          <div class="row">
            <div class="col">
              <div class="text-center">
                <h2>Common questions</h2>
              </div>
            </div>
          </div>
          <br/>
          <br/>
          <div class="row">
            <div class="col">
              <h4 class="questions">How does the membership work?</h4>
              <p class="answers">
                Your membership begins upon signup. We recommend downloading the app! You'll be able to see all the coworking spaces nearby. Pick a
                spot with available seats and when you arrive, "check in" with the app. We'll let the community manager know you're here with
                Croissant, so you can just take a seat and get comfy. Just remember to "check out" when you leave.
              </p>
              <br/>
              <h4 class="questions">Do I have to commit for a certain period of time?</h4>
              <p class="answers">Nope. Cancel anytime before your next renewal via your account settings if you don’t think Croissant is right for you. No hard feelings ❤️</p>
              <br/>
              <h4 class="questions">Which plan should I choose?</h4>
              <p class="answers">It depends on how many hours you'd like to cowork each month. You can switch your plan at any time, as well as purchase extra hours, so no worries if you aren't sure.</p>
              <br/>
              <h4 class="questions">Do you have team accounts?</h4>
              <p class="answers">Yes! Learn more and book a demo <a routerLink="/team-plans" style="text-decoration:underline;">here</a>.</p>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Images -->
  <div class="section-images">
    <div class="container-fluid g-0">
      <div class="row g-0">
        <div class="col-12 col-sm-6">
          <picture>
            <source srcset="/images/membership/place-bond.webp" type="image/webp">
            <img src="/images/membership/place-bond.jpg" class="img img-responsive" alt="Bond coworking space"/>
          </picture>
        </div>
        <div class="col-12 col-sm-6 hide-sm">
          <picture>
            <source srcset="/images/membership/place-impacthub.webp" type="image/webp">
            <img src="/images/membership/place-impacthub.jpg" class="img img-responsive" alt="Impact Hub coworking space"/>
          </picture>
        </div>
      </div>
    </div>
  </div>

</div>
